import { app } from '@packages/app';
import { ReduxServiceProvider } from '@redux-src/ReduxServiceProvider';
import { Action } from 'redux';

export const action = (action: Action) => {
    const reduxService: ReduxServiceProvider = app(ReduxServiceProvider);

    return reduxService.dispatch(action);
};
